import clsx from "clsx";

interface IProps {
  children: React.ReactNode;
  hidden?: boolean;
  isPublic?: boolean;
  id?: string;
}

const ProfileSectionsContainer = ({ children, hidden = false, isPublic = false, id }: IProps) => {
  if (hidden || !children) return null;
  return (
    <div
      className={clsx("flex flex-col dd:py-0 py-6", !isPublic && "dm:px-px")}
      id={id}
    >
      {children}
    </div>
  );
};

export default ProfileSectionsContainer;
